// Parceiros institucionais confirmados (ex.: Missão Católica Portuguesa de Luzern)
export const SHOW_INSTITUTIONAL = true;

// Página oficial do evento na Ticketcorner (parceiro oficial de vendas)
export const TICKETCORNER_URL = "https://www.ticketcorner.ch/artist/fados-a-mesa-a-portuguese-evening/";
